export function hotelSelectedRouting({ hotelId }, currentRoute) {
    return [
        {
            pathname: `${currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.route}/${hotelId}`,
            query: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.query,
        },
    ];
}
